/*
 * module.js - The description of the module.
 */

Fundu.Components.Diagram = (function($, nv) {

    // State
    ///////////////////////////
    var _isInitialized = false;

    // Properties
    ///////////////////////////
    var _diagramElements = false;

    // Private Methods
    ///////////////////////////

    // Select elements from HTML
    var checkElements = function() {
        return true;
    }

    // Init
    ///////////////////////////
    var initialize = function(element) {
        if(_isInitialized) return true;

        _diagramElements = element;

        var success = checkElements();
        if (success) {
            initializeDiagrams();
            _isInitialized = true;
            return true;
        }

        return false;
    }

    var createProgressDonut = function(element){
        $(element).knob({
            "bgColor": "#E7E7E7",
            "fgColor": "#249D0A",
            "angleOffset": -125,
            "angleArc": 250,
            "cursor": false,
            "displayInput": true,
            "readOnly": true,
            "thickness": ".28",
            'format': function (value){
                return value + '%';
            }
        });
    }

    var createDiscreteBar = function(element){
        if($(element).length === 0) return false;

        element = $(element);

        // Create svg
        element.append('<svg class="discrete-bar"></svg>');

        var width = Math.floor(element.innerWidth());
        if(width < 300 )
            width = 300;

        var height =  Math.floor(width / 2);

        element.css('height', height);

        var variableName = "chartData" + element.data('dataset');
        var id = element.attr('id');
        var selector = "#" + id + " .discrete-bar";

        var data = [{
            key: title,
            values: window[variableName]
        }];
        var title = element.data("title");

        if(typeof data !== "undefined"){
            var chart = nv.models.discreteBarChart()
                                 .x(function(d) {
                                    return d.name
                                 })
                                 .y(function(d) {
                                     return parseInt(d.value)
                                 })
                                 .staggerLabels(true)
                                 //.staggerLabels(historicalBarChart[0].values.length > 8)
                                 .showValues(true)
                                 .duration(250)
                                 .width(width)
                                 .height(height);

            chart.color(["#d91e41"])
                 .tooltip.enabled(false);

            d3.select(selector)
              .datum(data)
              .call(chart);
            nv.utils.windowResize(chart.update);
            return chart;
        }
    }

    var createDonut = function(element){
        if($(element).length === 0) return false;

        element = $(element);

        // Create svg
        element.append('<svg class="donut"></svg>');

        var width = Math.floor(element.innerWidth());
        if(width < 300 )
            width = 300;

        var height = width;

        element.css('height', height);

        var variableName = "chartData" + element.data('dataset');
        var id = element.attr('id');
        var selector = "#" + id + " .donut";
        var data = window[variableName];
        var title = element.data("title");

        if(typeof data !== "undefined"){

            nv.addGraph(function() {
                var chart = nv.models.pieChart()
                    .x(function(d) { return d.name })
                    .y(function(d) { return parseInt(d.amount) })
                    .donut(true)
                    .width(width)
                    .height(height)
                    .cornerRadius(0)
                    .showLegend(false)
                    .id(id+"DonutGraph"); // allow custom CSS for this one svg

                chart.title(title);
                chart.legendPosition('right');
                chart.pie.color(["#96152d", "#ac1834", "#c31b3a", "#d91e41", "#e22e50", "#e54563", "#e85b76"])
                         .labelsOutside(true)
                         .donut(true);

                chart.tooltip.chartContainer(element[0])
                             .fixedTop(null);

                d3.select(selector)
                    .datum(data)
                    .transition().duration(1200)
                    .call(chart);

                chart.tooltip.fixedTop(null)
                            .valueFormatter(function (d) { return d + "€"; });
                return chart;
            });
        }
    }

    var initializeDiagrams = function(){
        var diagramsFound = $('.diagram');

        if(diagramsFound.length > 0){
            diagramsFound.each(
                function(index){
                    var type = $(this).data('diagram');

                    if(type) {
                        switch (type) {
                            case "progress-dial":
                                setTimeout(
                                    function(){
                                        createProgressDonut(this);
                                    }.bind(this), 85
                                );
                                break;
                            case "donut":
                                setTimeout(
                                    function(){
                                        createDonut(this);
                                    }.bind(this), 85
                                );
                                break;

                            case "discrete-bar":
                                setTimeout(
                                    function(){
                                        createDiscreteBar(this);
                                    }.bind(this), 85
                                );
                                break;
                        }
                    }
                }
            );
        } else {
            console.log("No diagrams found");
        }
        return true;
    }

    // Public Methods
    ///////////////////////////

    // Reveal public methods
    return {
        init: initialize
    }

})(jQuery, nv);
